import { render, staticRenderFns } from "./VerificationData.vue?vue&type=template&id=7a4eb04a&scoped=true&lang=pug&"
import script from "./VerificationData.vue?vue&type=script&lang=js&"
export * from "./VerificationData.vue?vue&type=script&lang=js&"
import style0 from "./VerificationData.vue?vue&type=style&index=0&id=7a4eb04a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4eb04a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src142773959/src/bsix_meet_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a4eb04a')) {
      api.createRecord('7a4eb04a', component.options)
    } else {
      api.reload('7a4eb04a', component.options)
    }
    module.hot.accept("./VerificationData.vue?vue&type=template&id=7a4eb04a&scoped=true&lang=pug&", function () {
      api.rerender('7a4eb04a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/fv_atril_video/VerificationData.vue"
export default component.exports